import { alpha } from '@mui/material';
import { grey } from '@client/theme/colors';
import { theme } from '@client/theme/constants';

let { shadows: themeShadows } = theme;
themeShadows[2] = `0px 3px 20px 0px ${alpha(grey[600], 0.25)} inset`; // inset shadow
themeShadows[4] = `0px 3px 10px ${alpha(grey[600], 0.25)}`; // outer shadow
themeShadows[5] = `0px 4px 40px 0px ${alpha(grey[600], 0.3)}`; // outer shadow 2

export const shadows = themeShadows;
